export default {
    'add-new-review': 'Add New Review'
}